export default function($) {

  let postsSwiper = document.querySelector('.js-posts-slider');

  const postsSwiperParams = {
    slidesPerView: 1.4,
    slidesPerGroupSkip: 0,
    loop: true,
    centeredSlides: true,
    spaceBetween: 8,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      480: {
        spaceBetween: 16,
      },
      640: {
        spaceBetween: 32,
      }
    },
    on: {
      destroy: function() {
        $('.swiper-pagination').hide();
        $('.swiper-button').hide();
      },
      init: function() {
        $('.swiper-pagination').show();
        $('.swiper-button').show();
      },
    },
  };

  function swiperDisplay(e) {
    if( $(window).width() < 1024 && !postsSwiper.initialized ) {
      postsSwiper = new Swiper('.js-posts-slider', postsSwiperParams);
    }
    else if( $(window).width() >= 1024 ) {
      if( postsSwiper.initialized ) {
        postsSwiper.destroy(false,true);
        $('.js-posts-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('.swiper-pagination').hide();
        $('.swiper-button').hide();
      }
    }
  }

  if( $('.js-posts-slider').length > 0 ) {
    swiperDisplay();

    $(window).resize(function() {
      swiperDisplay();
    });
  }

  const reviewsSwiper = new Swiper('.js-reviews-slider', {
    autoplay: 10000,
    speed: 2000,
    autoplay: {
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    centeredSlides: true,
    loop: true,
    slidesPerView: 1.2,
    spaceBetween: 32,
    breakpoints: {
      768: {
        slidesPerView: 2.2,
        centeredSlides: false,
      },
      1280: {
        slidesPerView: 3.2,
        centeredSlides: false,
        spaceBetween: 56,
      },
      1536: {
        slidesPerView: 4.2,
        centeredSlides: false,
        spaceBetween: 56,
      },
    },
  });

  const relatedProductsSwiper = new Swiper('.js-related-products-slider', {
    centeredSlides: true,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 32,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      enabled: false,
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        centeredSlides: false,
        loop: false,
        navigation: {
          enabled: true,
        },
      },
      1024: {
        slidesPerView: 3,
        centeredSlides: false,
        loop: false,
        navigation: {
          enabled: true,
        },
      },
      1536: {
        slidesPerView: 3,
        spaceBetween: 56,
        centeredSlides: false,
        loop: false,
        navigation: {
          enabled: true,
        },
      },
    },
  });

  const productsSwiper = new Swiper('.js-products-slider', {
    slidesPerView: 1,
    spaceBetween: 16,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      480: {
        spaceBetween: 32,
      },
    },
    on: {
      init: function() {
        $('.swiper-button').removeClass('hidden');
      },
    },
  });

  const catalogsSwiper = new Swiper('.js-catalogs-slider', {
    slidesPerView: 2,
    spaceBetween: 16,
    slidesPerGroup: 2,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      640: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      1248: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
    }
});

}
